
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 14 13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.571 0c3.63 0 6.572 2.873 6.572 6.417 0 3.543-2.943 6.416-6.572 6.416S0 9.96 0 6.417C0 2.873 2.942 0 6.571 0zm0 1.167c-2.97 0-5.376 2.35-5.376 5.25s2.407 5.25 5.376 5.25c2.97 0 5.377-2.35 5.377-5.25S9.54 1.167 6.57 1.167zm0 1.166c.307 0 .56.226.594.516l.004.068v3.14l2.059 1.005a.578.578 0 01.295.72l-.028.062a.603.603 0 01-.737.288l-.064-.027-2.39-1.167a.584.584 0 01-.325-.449l-.005-.072v-3.5a.59.59 0 01.597-.584z","fill":"#fff"}})])
          )
        }
      }
    